export default __webpack_public_path__ + "static/media/8811ea124d158bb3.77b75982987105251ea730cda6db0949.svg";